export default function getDefaults() {
  return {
    enabled: true,
    hidden: false,
    respectReducedMotion: true,
    minTargetSize: 24,
    chartLabel: 'Chart',
    chartRoleDescription: 'chart',
    plotLabel: 'Chart values',
    seriesLabel: 'Chart series',
    categoryAxisLabel: 'Category axis',
    valueAxisLabel: 'Value axis',
    legendLabel: 'Legend',
    tooltipLabel: 'Tooltip values',
    tooltipPreviousLabel: 'Previous category',
    tooltipNextLabel: 'Next category'
  };
}
